export enum StepType {
    Acquisition,
    Script,
    States,
    Reconciliation,
    Alarms
}